import React, { useEffect } from 'react';

import Nav from './Nav';
import IMG from '../../img/San Roque 8.jpg';

const Menu = () => {
    useEffect(() => {
        let options_menu = document.querySelectorAll(
            '.orb-fs-menu .orb-has-children.orb-has-menu, .orb-fs-menu .orb-has-children.orb-has-link'
        );
        options_menu.forEach((option) => {
            option.addEventListener('click', () => {
                let option_active = option.querySelector('ul');
                let option_status;

                if (option_active !== null) {
                    option_status =
                        option_active.classList.contains('orb-active');
                }

                let uls = document.querySelectorAll(
                    '.orb-fs-menu .orb-has-children ul, .orb-fs-menu .orb-has-children a'
                );
                uls.forEach((ul) => {
                    ul.classList.remove('orb-active');
                });
                if (option_status) {
                    option_active.classList.remove('orb-active');
                } else if (option_active !== null) {
                    option_active.classList.add('orb-active');
                }
            });
        });

        let links_menu = document.querySelectorAll(
            '.orb-fs-menu .orb-has-children ul li a, .orb-fs-menu .orb-has-children.orb-has-link'
        );
        links_menu.forEach((link) => {
            link.addEventListener('click', () => {
                closemenu();
            });
        });

        const closemenu = () => {
            let big_menu = document.querySelectorAll(
                '.orb-menu-btn, .orb-big-menu-frame, .orb-big-menu'
            );

            big_menu.forEach((big) => {
                big.classList.toggle('orb-active');
            });

            let top_bar = document.querySelector('.orb-top-bar-frame');
            top_bar.classList.toggle('orb-menu-opened');
        };
    }, []);

    return (
        <div className="orb-big-menu-frame">
            <div className="orb-big-menu orb-big-menu-2">
                <div className="orb-grid">
                    <div className="orb-g-33 orb-lg-50 orb-sm-100">
                        <div className="orb-menu-frame orb-fs-menu">
                            <Nav></Nav>
                        </div>
                    </div>
                    <div className="orb-g-33 orb-lg-50 orb-sm-100">
                        <div className="rb-object-frame">
                            <div className="orb-photo-frame orb-obj-1">
                                <img
                                    src={IMG}
                                    alt="San Roque"
                                    className="san"
                                ></img>
                            </div>
                        </div>
                    </div>
                    <div className="orb-g-33 orb-lg-50 orb-sm-100">
                        <div className="orb-menu-text-frame">
                            <div className="orb-menu-text">
                                <p>
                                    La Fiesta de San Roque de Tarija declarada
                                    por la Unesco como Patrimonio Inmaterial de
                                    la Humanidad.
                                </p>
                            </div>
                            <span className="orb-instagram">
                                #TarijaVinoParaQuedarse
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Menu;
